/* istanbul ignore file */
import IconArrowDown from './icon-arrow-down/IconArrowDown';

export default IconArrowDown;
